export default __webpack_public_path__ + "static/media/step4regis.057417ac.svg";